import React, { useEffect } from 'react';
import { FilterCheckboxBase } from '../filter-bases';
import { Box } from '@spothero/ui';
import { toggleShowUnavailable } from 'store/filters/filters-actions';
import { useDispatch, useSelector } from 'react-redux';
import { loadSpotsTransientV2 } from 'store/spots/spots-actions-v2';
import { SEARCH_TRACKING_ACTIONS } from 'utils/search-tracking';
import { useSortBy } from 'hooks/use-sort-by';
export const UnavailableSpotsToggle = () => {
    const adminShowUnavailableSpots = useSelector((state) => state.filters.showUnavailable);
    const searchData = useSelector((s) => s.search.data);
    const searchType = searchData?.searchType || '';
    const sortBy = useSortBy();
    const dispatch = useDispatch();
    const onClick = () => {
        dispatch(toggleShowUnavailable(!adminShowUnavailableSpots));
        dispatch(loadSpotsTransientV2({
            searchTrackingAction: SEARCH_TRACKING_ACTIONS.HERO_SEARCH,
            locationContext: searchType,
            sortBy: sortBy ?? undefined,
        }));
    };
    useEffect(() => {
        dispatch(toggleShowUnavailable(true));
        dispatch(loadSpotsTransientV2({
            searchTrackingAction: SEARCH_TRACKING_ACTIONS.HERO_SEARCH,
            locationContext: searchType,
            sortBy: sortBy ?? undefined,
        }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (<Box margin="auto">
            <FilterCheckboxBase onClick={onClick} isActive={!adminShowUnavailableSpots} testid="QuickFilters-filter-unavailable-spots">
                User View
            </FilterCheckboxBase>
        </Box>);
};
